const PostHogEvents = {
  UPB_PAGE_VIEWED: 'UPB Viewer Page Viewed',
};

export default PostHogEvents;
